import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=16bbbe6a&scoped=true"
import script from "./TextTooltip.vue?vue&type=script&lang=js"
export * from "./TextTooltip.vue?vue&type=script&lang=js"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=16bbbe6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bbbe6a",
  null
  
)

export default component.exports